<template>
  <div class="main-div" v-if="showProNumber || showMacropoint">
    <!-- PRO NUMBER mode -->
    <template v-if="showProNumber">
      <i
        class="copy-icon pi pi-copy"
        v-b-popover.hover.top="'Copy text'"
        @click="copyProNumber()"
      ></i>
      <a
        v-if="linkTracking !== ''"
        class="link-reference"
        target="_blank"
        :href="linkTracking"
      >
        {{ params.pro_number }}
      </a>
      <a
        v-if="linkTracking === ''"
        class="link-reference"
        @click="undefinedLink()"
      >
        {{ params.pro_number }}
      </a>
      <a
        v-if="linkTracking !== ''"
        target="_blank"
        :href="linkTracking"
      >
        <i class="pi pi-link icon-link"></i>
      </a>
      <i
        v-if="linkTracking === ''"
        class="pi pi-link icon-link"
        @click="undefinedLink()"
      ></i>
    </template>

    <!-- MACROPOINT mode (SHP) -->
    <template v-else-if="showMacropoint">
      <i
        class="copy-icon pi pi-copy"
        v-b-popover.hover.top="'Copy text'"
        @click="copyMacropointLink()"
      ></i>
      <a
        class="link-reference"
        target="_blank"
        :href="params.macropoint_tracking_link"
      >
        {{ params.name }}
      </a>
      <a target="_blank" :href="params.macropoint_tracking_link">
        <i class="pi pi-link icon-link"></i>
      </a>
    </template>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import copy from "copy-to-clipboard";
import CarrierTrackingLink from "../../Extend/CarrierTrackingLink";

const MACROPOINT_BASE_URL = "https://visibility.macropoint.com/";

export default {
  name: "load-pro-number",
  props: {
    params: {
      type: Object,
    },
  },
  components: {
    copy,
  },
  mixins: [CarrierTrackingLink],
  computed: {
    isValidMacropointLink() {
      return !!this.params.macropoint_tracking_link?.includes(MACROPOINT_BASE_URL);
    },
    isProNumberMode() {
      const mode = this.params.mode_name?.toLowerCase() ?? "";
      return [
        "air freight domestic",
        "ltl",
        "ltl canada",
        "ltl offshore",
        "ltl mexico",
        "parcel",
      ].includes(mode);
    },
    showProNumber() {
      const hasProNumber = !!this.params.pro_number;
      if (!hasProNumber) return false;
      if (this.isValidMacropointLink) {
        return this.isProNumberMode;
      }
      return true;
    },
    showMacropoint() {
      if (!this.isValidMacropointLink) return false;
      if (this.params.pro_number) {
        return !this.isProNumberMode;
      }
      return true;
    },
    linkTracking() {
      if (!this.params.carrier) {
        return "";
      }
      return this.searchTrackingLink(
        this.params.carrier?.name,
        this.params.pro_number
      );
    },
  },
  methods: {
    undefinedLink() {
      this.swal({
        title: "Info",
        text: this.$t("myLoads.messageLinkCarrier"),
        icon: "warning",
      });
    },
    copyProNumber() {
      copy(this.params.pro_number);
    },
    copyMacropointLink() {
      copy(this.params.macropoint_tracking_link);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
.icon-filters {
  width: 13px;
  height: 13px;
  transition: opacity 0.2s;
}

.main-div {
  position: relative;
  display: block;
  align-items: center;
}

.link-reference {
  cursor: pointer;
  text-decoration: underline;
  color: $color-border-container;
  white-space: nowrap;
  margin-left: 5px;
  flex: 1 1 auto;
  min-width: 0;
}

.icon-link {
  font-size: 11px;
  color: $color-border-container;
  cursor: pointer;
  margin-left: 5px;
}

.copy-icon {
  font-size: 12px;
  color: $color-border-container;
  cursor: pointer;
  display: none;
}

.main-div:hover .copy-icon {
  display: inline-block;
}
</style>
